module.exports = __webpack_public_path__ + "img/krungsri.6d23406c.png";